import { createFileRoute } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
import { categorySearchSchema } from "../../../helpers/search.helpers";
import LessonPage from "../../../pages/LessonPage/LessonPage";

export const Route = createFileRoute(
  "/(app)/courses_/$type/$publicCourseUuid/lessons/$publicLessonUuid"
)({
  component: RouteComponent,
  validateSearch: zodValidator(
    categorySearchSchema.extend({
      e: fallback(z.string().optional(), undefined),
    })
  ),
});

function RouteComponent() {
  return <LessonPage />;
}
